import { render } from "./ServicesBackCard.vue?vue&type=template&id=4cdd5379&scoped=true&ts=true"
import script from "./ServicesBackCard.vue?vue&type=script&lang=ts"
export * from "./ServicesBackCard.vue?vue&type=script&lang=ts"

import "./ServicesBackCard.vue?vue&type=style&index=0&id=4cdd5379&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cdd5379"]])

export default __exports__